module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-plus-0cfaffe7.svg";